import React, {Fragment, useEffect, useState} from 'react';
import './ProfileHeader.css';
import Menu from "../../../Components/Menu/Menu";
import axios from "axios";
import {Navigate, useNavigate} from "react-router-dom";
import loadingGif from "../../ChooseCorts/loading.gif";
import {isMobile} from "react-device-detect";

const ProfileHeader = ({ isWhite = true}) => {

    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [auth, setAuth] = useState(null);

    useEffect(() => {
        axios.get(`/api/my_name/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                setAuth(true);
                setName(res.data.name);
                console.log(res.data.name);
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
                else {
                    setAuth(false);
                    // setAuth(true); // delete after
                }
            })
    }, [setName, setAuth]);

    // if (auth === null) {
    //     return (<div className={'loading-block-auth'}><img src={loadingGif} alt={'Loading...'}
    //                                                        className={'loading-gif-auth'}/></div>);
    // }
    //
    // if (auth === false) {
    //     return (<div className={'access-error'}>Неполадки с доступом, попробуйте зайти позже.</div>);
    // }

    return (
        <div className={'profile-header-container'}>
            <Menu />
            {(isMobile) &&
                <Fragment>
                    <div className={'profile-header-user-photo'}></div>
                    <p className={`profile-header-user-name ${isWhite ? '' : 'profile-header-user-name-color'}`}>{name}</p>
                </Fragment>
            }
        </div>
    );
};

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default ProfileHeader;